<template>
</template>

<script>
export default {
  name: 'SignUp',
  async created() {

    if (this.$route.query.referralcode)
      sessionStorage.setItem('referralcode', this.$route.query.referralcode);

    const state = Date.now();
    sessionStorage.setItem('oauthState', state);

    let code_challenge = ''
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < 128; i++ )
      code_challenge += characters.charAt(Math.floor(Math.random() * characters.length));
    sessionStorage.setItem('oauthCode', code_challenge);

    location.href = `${process.env.VUE_APP_AUTH_SERVERURL}/createaccount?client_id=${process.env.VUE_APP_AUTH_CLIENTID}&redirect_uri=${process.env.VUE_APP_PURTRAK_URL}/login&state=${state}&response_type=code&code_challenge=${code_challenge}&code_challenge_method=S256`;
  }
}
</script>
